import { startOfWeek as e } from "./startOfWeek.js";
function o(a, r, t) {
  const f = e(a, t), k = e(r, t);
  return +f == +k;
}
export {
  o as default,
  o as isSameWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isSameWeek.js
// module id = 850
// module chunks = 41